/* eslint-disable */
import React, { useState, useContext, useEffect } from "react";
import { Button, Form } from "react-bootstrap";
import { Link, useNavigate, useLocation, useParams } from "react-router-dom";
import { SCHEMES_URL } from "../../Shared/constant";
import EmptySpaceFieldValid from "../../Common/EmptySpaceFieldValid";
import CheckValid from "../../Common/CheckValid";
import { useSelector, useDispatch } from "react-redux";
import { WebSocketContext } from "../../../App";
import wsSend_request from "../../../Api/ws/ws_request";
import { default as ReactSelect, components } from "react-select";
import DatePicker from "react-datepicker";
import CommonDateTime from "../../Common/CommonDateTime";
import { ClearFormSetFutios } from "../../../redux/actions/adminActions";
import CommonScrollBar from "../../Common/CommonScrollBar";
import AddUpdateProductSchemeAPI from "../../../Api/AddUpdateProductSchemeAPI";
import { toast } from "react-toastify";

const AddSchemes = () => {
  const Navigate = useNavigate();
  const Dispatch = useDispatch();
  const LocationRoute = useLocation()?.pathname?.split("/")[1];
  const { websocket } = useContext(WebSocketContext);
  const [ApplicationState, setApplicationState] = useState({
    SchemeName: "",
    AppGroup: [],
    ProductName: [],
    IncentiveCode: [],
    StartDate: "",
    EndDate: "",
    Status: true,
  });
  const {
    ClearFormSet,
    device_id,
    productlistall,
    IncentiveSlabList,
    franchiseSchemeList,
    accessToken,
  } = useSelector((state) => state.adminReducers);

  const IncentiveSlabs = IncentiveSlabList?.list?.map((elm) => elm?.app_group);
  const optionAppGroup = Object.values(
    productlistall
      ?.filter((elm) => IncentiveSlabs.includes(elm?.app_group))
      ?.reduce((acc, item) => {
        if (item?.app_group_id !== null && item?.app_group !== null) {
          if (!acc[item.app_group]) {
            acc[item.app_group] = {
              key: item.app_group_id,
              value: item.app_group_id,
              label: item.app_group,
              product_ids: [],
            };
          }
          acc[item.app_group].product_ids.push(item.id);
        }
        return acc;
      }, {}),
  );

  const [optionsProduct, setoptionsProduct] = useState([]);
  const [optionsIncentiveSlabs, setoptionsIncentiveSlabs] = useState([]);
  const [selectAllAppGroup, setselectAllAppGroup] = useState(false);
  const [selectAllProduct, setselectAllProduct] = useState(false);
  const [selectAllIncentiveSlab, setselectAllIncentiveSlab] = useState(false);

  // error state
  const [errorSchemeName, seterrorSchemeName] = useState("");
  const [errorAppGroup, seterrorAppGroup] = useState("");
  const [errorProductName, seterrorProductName] = useState("");
  const [errorIncentiveCode, seterrorIncentiveCode] = useState("");
  const [errorStartDate, seterrorStartDate] = useState("");
  const [errorEndDate, seterrorEndDate] = useState("");

  const { roomId } = useParams();
  const CurrentData_ = franchiseSchemeList?.list?.filter(
    (elm) => elm?.id === roomId,
  )[0];

  // update incentive groups into list
  const UpdateIncentiveSlabList = Object.values(
    IncentiveSlabList?.list?.reduce(
      (
        acc,
        {
          title,
          incentive_code,
          app_group,
          slab,
          range_from,
          range_to,
          amount,
        },
      ) => {
        if (!acc[incentive_code]) {
          acc[incentive_code] = {
            title,
            incentive_code,
            app_group,
            incentives: [],
          };
        }

        // Push slab details to the incentives array
        acc[incentive_code].incentives.push({
          slab,
          range_from,
          range_to,
          amount,
        });

        return acc;
      },
      {},
    ),
  );

  const optionsIncentiveSlabsUpdate = UpdateIncentiveSlabList?.map(
    (item, index) => ({
      key: item.incentive_code,
      value: item?.incentive_code,
      label: item?.title,
      app_group: item?.app_group,
    }),
  );

  const customStylesNew = {
    option: (provided, state) => ({
      ...provided,
      fontSize: "13px", // Adjust the font size as per your requirement
      display: "flex",
      columnGap: "7px",
    }),
    multiValue: (provided) => ({
      ...provided,
      fontSize: "13px", // Set your desired font size here
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      fontSize: "13px", // Set the font size of the label inside each selected tag
    }),
    multiValueRemove: (provided) => ({
      ...provided,
      fontSize: "13px", // Set the font size of the remove icon if needed
    }),
    valueContainer: (base) => ({
      ...base,
      overflow: "auto",
      maxHeight: "62px",
    }),
  };

  // get all product list
  useEffect(() => {
    let param = {
      transmit: "broadcast",
      url: "product_list",
      request: {
        status: true,
        limit: 5000,
        page_no: 1,
        search: "",
      },
      DeviceId: device_id,
    };
    wsSend_request(websocket, param);
  }, [websocket]);

  useEffect(() => {
    let param = {
      transmit: "broadcast",
      url: "salesperson_incentive_slab",
      request: {
        status: true,
        limit: 5000,
        search: "",
      },
      DeviceId: device_id,
    };
    wsSend_request(websocket, param);
  }, [websocket]);

  // datepicker selctions
  const DateGet = (value, url) => {
    if (value !== null) {
      if (url === "start_date") {
        setApplicationState({
          ...ApplicationState,
          StartDate: value,
          EndDate: "",
        });
        seterrorStartDate("");
      } else {
        setApplicationState({
          ...ApplicationState,
          EndDate: value,
        });
        seterrorEndDate("");
      }
    } else {
      if (url === "start_date") {
        setApplicationState({
          ...ApplicationState,
          StartDate: "",
          EndDate: "",
        });
        seterrorStartDate("Please select start date");
      } else {
        setApplicationState({
          ...ApplicationState,
          EndDate: "",
        });
        seterrorEndDate("Please select end date");
      }
    }
  };

  // App Group Select
  const AppGroupOnChange = (value) => {
    setselectAllProduct(false);
    setselectAllAppGroup(false);
    setselectAllIncentiveSlab(false);
    if (value?.length > 0) {
      setApplicationState({
        ...ApplicationState,
        AppGroup: value,
        ProductName: "",
        IncentiveCode: "",
      });
      CheckValid(value, { type: "AppGroupSelect", error: seterrorAppGroup });
    } else {
      setApplicationState({
        ...ApplicationState,
        AppGroup: "",
        ProductName: "",
        IncentiveCode: "",
      });
      CheckValid("", { type: "AppGroupSelect", error: seterrorAppGroup });
    }
  };

  // Product select
  const ProductSelect = (value) => {
    if (value?.length > 0) {
      setApplicationState({
        ...ApplicationState,
        ProductName: value,
      });
      CheckValid(value, { type: "ProductSelect", error: seterrorProductName });
    } else {
      setApplicationState({
        ...ApplicationState,
        ProductName: "",
      });
      CheckValid("", { type: "ProductSelect", error: seterrorProductName });
    }
  };

  // AFTER SELECTING SELECT ALL THEN ALL APP GROUP WILL BE SELECTED
  useEffect(() => {
    if (selectAllAppGroup) {
      setApplicationState({
        ...ApplicationState,
        AppGroup: optionAppGroup,
        ProductName: "",
        IncentiveCode: "",
      });
    } else {
      setApplicationState({
        ...ApplicationState,
        AppGroup: "",
        ProductName: "",
        IncentiveCode: "",
      });
    }
  }, [selectAllAppGroup]);

  // AFTER SELECTING SELECT ALL THEN ALL PRODUCT WILL BE SELECTED
  useEffect(() => {
    if (selectAllProduct) {
      setApplicationState({
        ...ApplicationState,
        ProductName: optionsProduct,
      });
    } else {
      setApplicationState({
        ...ApplicationState,
        ProductName: "",
      });
    }
  }, [selectAllProduct]);

  // AFTER SELECTING SELECT ALL THEN ALL INCENTIVE SLAB WILL BE SELECTED
  useEffect(() => {
    if (selectAllIncentiveSlab) {
      setApplicationState({
        ...ApplicationState,
        IncentiveCode: optionsIncentiveSlabs,
      });
    } else {
      setApplicationState({
        ...ApplicationState,
        IncentiveCode: "",
      });
    }
  }, [selectAllIncentiveSlab]);

  // Incentive Slab select
  const IncentiveSlabSelect = (value) => {
    if (value?.length > 0) {
      setApplicationState({
        ...ApplicationState,
        IncentiveCode: value,
      });
      CheckValid(value, {
        type: "IncentiveCode",
        error: seterrorIncentiveCode,
      });
    } else {
      setApplicationState({
        ...ApplicationState,
        IncentiveCode: "",
      });
      CheckValid("", { type: "IncentiveCode", error: seterrorIncentiveCode });
    }
  };

  const isArray = (value) => {
    return Array.isArray(value) && value.length > 0;
  };

  useEffect(() => {
    if (
      ApplicationState?.AppGroup !== "" &&
      ApplicationState?.AppGroup !== null
    ) {
      const UpdateProductListing = productlistall
        ?.filter((elz) => {
          if (isArray(ApplicationState?.AppGroup)) {
            return ApplicationState?.AppGroup?.some(
              (elm) => elm?.label === elz?.app_group,
            );
          } else {
            return ApplicationState?.AppGroup?.label === elz?.app_group;
          }
        })
        ?.map((item, index) => ({
          key: item.id,
          value: item?.id,
          label: item?.product_name,
          app_group: item?.app_group,
        }));
      setoptionsProduct(UpdateProductListing);
    } else {
      setoptionsProduct(
        productlistall?.map((item, index) => ({
          key: item.id,
          value: item?.id,
          label: item?.product_name,
          app_group: item?.app_group,
        })),
      );
    }
  }, [ApplicationState?.AppGroup]);

  useEffect(() => {
    if (
      ApplicationState?.AppGroup !== "" &&
      ApplicationState?.AppGroup !== null
    ) {
      const UpdateProductListing = optionsIncentiveSlabsUpdate?.filter(
        (elz) => {
          if (isArray(ApplicationState?.AppGroup)) {
            return ApplicationState?.AppGroup?.some(
              (elm) => elm?.label === elz?.app_group,
            );
          } else {
            return ApplicationState?.AppGroup?.label === elz?.app_group;
          }
        },
      );
      setoptionsIncentiveSlabs(UpdateProductListing);
    } else {
      setoptionsIncentiveSlabs(optionsIncentiveSlabsUpdate);
    }
  }, [ApplicationState?.AppGroup]);

  useEffect(() => {
    if (LocationRoute === "edit-schemes") {
      setTimeout(() => {
        const CureentAppGroup = optionAppGroup?.filter((elm) =>
          CurrentData_?.app_group?.split(",")?.includes(elm?.label),
        );
        const CurrentIncentive = optionsIncentiveSlabsUpdate?.filter((elm) =>
          CurrentData_?.incentive_code?.split(",")?.includes(elm?.value),
        );
        const UpdateProduct = CurrentData_?.product_details?.map(
          (item, index) => ({
            key: item.product_id,
            value: item?.product_id,
            label: item?.product_name,
            app_group: item?.app_group,
          }),
        );

        setApplicationState({
          ...ApplicationState,
          SchemeName: CurrentData_?.scheme_name,
          AppGroup: CureentAppGroup,
          IncentiveCode: CurrentIncentive,
          ProductName: UpdateProduct,
          StartDate: new Date(CurrentData_?.start_date),
          EndDate: new Date(CurrentData_?.end_date),
          Status: true,
        });
      }, 500);
    }
  }, [CurrentData_]);

  // create Add Schemes
  const AddSchemesFct = async () => {
    if (
      ApplicationState?.SchemeName !== "" &&
      ApplicationState?.ProductName?.length > 0 &&
      ApplicationState?.AppGroup?.length > 0 &&
      ApplicationState?.IncentiveCode?.length > 0 &&
      ApplicationState?.StartDate !== "" &&
      ApplicationState?.EndDate !== ""
    ) {
      try {
        let incentive_code_Array = ApplicationState?.ProductName?.map((elm) => {
          const CurrentIncenvtiveCode = ApplicationState?.IncentiveCode?.find(
            (elz) => elz?.app_group === elm?.app_group,
          );
          return {
            id: elm?.value,
            app_group: elm?.app_group,
            incentive_code: CurrentIncenvtiveCode?.value,
          };
        });

        if (LocationRoute === "edit-schemes") {
          incentive_code_Array = ApplicationState.ProductName.map(
            (elm) => {
              const product = productlistall.find(
                (item) => item.id === elm.value,
              );

              const incentive = IncentiveSlabList.list.find(
                (item) => item.app_group === product?.app_group,
              );

              return {
                id: elm.value,
                app_group: product?.app_group,
                incentive_code: incentive?.incentive_code,
              };
            },
          );
        }

        let payload = {
          scheme_name: ApplicationState?.SchemeName,
          product_ids: incentive_code_Array,
          incentive_code: ApplicationState?.IncentiveCode?.map(
            (elm) => elm?.value,
          )?.toString(),
          start_date: CommonDateTime(
            ApplicationState?.StartDate,
            "DD-MM-YYYY",
            "hide",
          ),
          end_date: CommonDateTime(
            ApplicationState?.EndDate,
            "DD-MM-YYYY",
            "hide",
          ),
          app_group: ApplicationState?.AppGroup?.map(
            (elm) => elm?.label,
          )?.toString(),
          is_active: ApplicationState?.Status,
        };
        if (LocationRoute === "edit-schemes") {
          payload.scheme_id = roomId;
        }
        const response = await AddUpdateProductSchemeAPI(accessToken, payload);

        if (!response?.success) {
          toast.error(
            response?.message || response?.error || "Something went wrong",
          );
          return;
        }

        toast.success(response?.message);
        Navigate(SCHEMES_URL);
      } catch (error) {
        toast.error(error?.message || "Something went wrong");
      }
    } else {
      CheckValid(ApplicationState?.SchemeName, {
        type: "SchemeName",
        error: seterrorSchemeName,
      });
      CheckValid(
        ApplicationState?.AppGroup?.length === 0
          ? ""
          : ApplicationState?.AppGroup,
        { type: "AppGroupSelect", error: seterrorAppGroup },
      );
      CheckValid(
        ApplicationState?.ProductName?.length === 0
          ? ""
          : ApplicationState?.ProductName,
        { type: "ProductSelect", error: seterrorProductName },
      );
      CheckValid(
        ApplicationState?.IncentiveCode?.length === 0
          ? ""
          : ApplicationState?.IncentiveCode,
        { type: "IncentiveCode", error: seterrorIncentiveCode },
      );

      if (ApplicationState?.StartDate === "") {
        seterrorStartDate("Please select start date");
      }
      if (ApplicationState?.EndDate === "") {
        seterrorEndDate("Please select end date");
      }
    }
  };

  const Option = (props) => {
    return (
      <div>
        <components.Option {...props}>
          <input
            type="checkbox"
            checked={props.isSelected}
            onChange={() => null}
          />{" "}
          <label>{props.label}</label>
        </components.Option>
      </div>
    );
  };

  useEffect(() => {
    if (
      ClearFormSet?.action === 200 &&
      ClearFormSet?.url === "product_scheme_add"
    ) {
      Navigate(SCHEMES_URL);
    }
  }, [ClearFormSet]);

  return (
    <section className="createApplcation_wrapper createScheme_wrapper">
      <div className="MainHeader">
        <Link to={SCHEMES_URL} className="btn btn-link backbtn">
          <i className="bi bi-arrow-left-short"></i> Back
        </Link>
      </div>
      <div className="tabs_main_relative_wraps">
        <CommonScrollBar
          className={"ScrollbarsSidebar"}
          height={{ height: "calc(100vh - 134px)" }}
        >
          <div className="tabsWrappers">
            <div className="formloginset">
              <div className="row">
                <div className="col-md-6">
                  <Form.Group className="mb-3">
                    <Form.Label>
                      Scheme Name <span className="mendatory_star">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      value={ApplicationState?.SchemeName}
                      onChange={(e) =>
                        setApplicationState({
                          ...ApplicationState,
                          SchemeName: e.target.value,
                        })
                      }
                      onKeyUp={(e) =>
                        CheckValid(e.target.value, {
                          type: "SchemeName",
                          error: seterrorSchemeName,
                        })
                      }
                      onKeyDown={EmptySpaceFieldValid}
                      placeholder="Enter Scheme Name"
                    />
                    {errorSchemeName !== "" && (
                      <span className="error_medotory">{errorSchemeName}</span>
                    )}
                  </Form.Group>
                </div>
                <div className="col-md-6">
                  <Form.Group className="mb-3">
                    <div
                      style={{
                        float: "left",
                        width: "100%",
                        fontSize: "14px",
                        marginBottom: ".5rem",
                      }}
                    >
                      App Group <span className="mendatory_star">*</span>
                      <label className="select_all_product">
                        <input
                          type="checkbox"
                          checked={selectAllAppGroup}
                          onChange={() => {
                            setselectAllAppGroup(!selectAllAppGroup);
                            setselectAllProduct(false);
                            setselectAllIncentiveSlab(false);
                            seterrorAppGroup("");
                          }}
                        />
                        Select All
                      </label>
                    </div>
                    <div
                      className="selectMultiselect"
                      id="selectMultiselectBrand"
                    >
                      <ReactSelect
                        onChange={(e) => AppGroupOnChange(e)}
                        value={ApplicationState?.AppGroup}
                        isClearable
                        options={optionAppGroup}
                        components={{
                          Option,
                        }}
                        isMulti
                        closeMenuOnSelect={false}
                        hideSelectedOptions={false}
                        className="godown-select-container"
                        classNamePrefix="godown-select"
                        placeholder="Select App Group"
                        styles={customStylesNew}
                        menuPlacement="auto"
                        menuPortalTarget={document.body}
                      />
                      {errorAppGroup !== "" && (
                        <span className="error_medotory">{errorAppGroup}</span>
                      )}
                    </div>
                  </Form.Group>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <Form.Group className="mb-3">
                    <div
                      style={{
                        float: "left",
                        width: "100%",
                        fontSize: "14px",
                        marginBottom: ".5rem",
                      }}
                    >
                      Products <span className="mendatory_star">*</span>
                      <label className="select_all_product">
                        <input
                          type="checkbox"
                          checked={selectAllProduct}
                          onChange={() => {
                            setselectAllProduct(!selectAllProduct);
                            seterrorProductName("");
                          }}
                          disabled={
                            ApplicationState?.AppGroup?.length > 0
                              ? false
                              : true
                          }
                        />
                        Select All
                      </label>
                    </div>
                    <div
                      className="selectMultiselect"
                      id="selectMultiselectBrand"
                    >
                      <ReactSelect
                        onChange={(e) => {
                          ProductSelect(e);
                          setselectAllProduct(false);
                        }}
                        value={ApplicationState?.ProductName}
                        isClearable
                        options={optionsProduct}
                        components={{
                          Option,
                        }}
                        isMulti
                        closeMenuOnSelect={false}
                        hideSelectedOptions={false}
                        className="godown-select-container"
                        classNamePrefix="godown-select"
                        placeholder="Select Products"
                        styles={customStylesNew}
                        menuPlacement="auto"
                        menuPortalTarget={document.body}
                        isDisabled={
                          ApplicationState?.AppGroup?.length > 0 ? false : true
                        }
                      />
                      {errorProductName !== "" && (
                        <span className="error_medotory">
                          {errorProductName}
                        </span>
                      )}
                    </div>
                  </Form.Group>
                </div>
                <div className="col-md-6">
                  <Form.Group className="mb-3">
                    <div
                      style={{
                        float: "left",
                        width: "100%",
                        fontSize: "14px",
                        marginBottom: ".5rem",
                      }}
                    >
                      Incentive Slab <span className="mendatory_star">*</span>
                      <label className="select_all_product">
                        <input
                          type="checkbox"
                          checked={selectAllIncentiveSlab}
                          onChange={() => {
                            setselectAllIncentiveSlab(!selectAllIncentiveSlab);
                            seterrorIncentiveCode("");
                          }}
                          disabled={
                            ApplicationState?.AppGroup?.length > 0
                              ? false
                              : true
                          }
                        />
                        Select All
                      </label>
                    </div>
                    <div
                      className="selectMultiselect"
                      id="selectMultiselectBrand"
                    >
                      <ReactSelect
                        onChange={(e) => {
                          IncentiveSlabSelect(e);
                          setselectAllIncentiveSlab(false);
                        }}
                        value={ApplicationState?.IncentiveCode}
                        isClearable
                        options={optionsIncentiveSlabs}
                        components={{
                          Option,
                        }}
                        isMulti
                        closeMenuOnSelect={false}
                        hideSelectedOptions={false}
                        className="godown-select-container"
                        classNamePrefix="godown-select"
                        placeholder="Select Incentive Slab"
                        styles={customStylesNew}
                        menuPlacement="auto"
                        menuPortalTarget={document.body}
                        isDisabled={
                          ApplicationState?.AppGroup?.length > 0 ? false : true
                        }
                      />
                      {errorIncentiveCode !== "" && (
                        <span className="error_medotory">
                          {errorIncentiveCode}
                        </span>
                      )}
                    </div>
                  </Form.Group>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <Form.Group className="mb-3">
                    <Form.Label>
                      Start Date <span className="mendatory_star">*</span>
                    </Form.Label>
                    <div className="datepickField datepickFieldSchome">
                      <DatePicker
                        selected={ApplicationState?.StartDate}
                        startDate={ApplicationState?.StartDate}
                        onChange={(date) => DateGet(date, "start_date")}
                        dateFormat="yyyy/MM/dd"
                        minDate={new Date()}
                        peekNextMonth
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        placeholderText="Enter Start Date"
                        isClearable={
                          ApplicationState?.StartDate !== "" ? true : false
                        }
                        autoComplete="off"
                      />
                      {errorStartDate !== "" && (
                        <span className="error_medotory">{errorStartDate}</span>
                      )}
                    </div>
                  </Form.Group>
                </div>
                <div className="col-md-6">
                  <Form.Group className="mb-3">
                    <Form.Label>
                      End Date <span className="mendatory_star">*</span>
                    </Form.Label>
                    <div className="datepickField datepickFieldSchome">
                      <DatePicker
                        selected={ApplicationState?.EndDate}
                        startDate={ApplicationState?.StartDate}
                        onChange={(date) => DateGet(date, "end_date")}
                        dateFormat="yyyy/MM/dd"
                        minDate={ApplicationState?.StartDate}
                        peekNextMonth
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        placeholderText="Enter Start Date"
                        isClearable={
                          ApplicationState?.EndDate !== "" ? true : false
                        }
                        disabled={ApplicationState?.StartDate === ""}
                        autoComplete="off"
                      />
                      {errorEndDate !== "" && (
                        <span className="error_medotory">{errorEndDate}</span>
                      )}
                    </div>
                  </Form.Group>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <Button
                    className="formbtn widthfullbtn"
                    disabled={
                      ClearFormSet?.action === true &&
                      ClearFormSet?.url === "product_scheme_add"
                    }
                    onClick={() => AddSchemesFct()}
                    variant="primary"
                  >
                    {LocationRoute === "edit-schemes" ? "Update" : "Add"}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </CommonScrollBar>
      </div>
    </section>
  );
};

export default AddSchemes;
